module.exports = {"primary":"#EF6569","danger":"#EF6569","red":"#EF6569","warning":"#F7C972","orange":"#F7C972","blue":"#3D8DBC","info":"#74D9E1","success":"#6AD988","light":"#f9f9f9","black":"#212121"}


//////////////////
// WEBPACK FOOTER
// ./ui/colors.json
// module id = 391
// module chunks = 0